import useSmallDesktopScreen from 'hooks/useSmallDesktopScreen';
import AppMenuDrawer from './AppMenuDrawer';
import MobileMenu from './MobileMenu';
import { useSelectedLinkContext } from 'contexts';
import { isSelfLink } from 'utils/link';

const AppMenu = (): JSX.Element | null => {
  const { selectedLink } = useSelectedLinkContext();
  const isSmallScreen = useSmallDesktopScreen();

  if (isSelfLink(selectedLink)) {
    return null;
  }
  
  if (isSmallScreen) {
    return (
      <MobileMenu />
    );
  }

  return (
    <AppMenuDrawer />
  );
};

export default AppMenu;
